import React, { useState } from 'react';
import {
    TextField,
    Button,
    Typography,
    Paper,
    Grid,
    MenuItem
} from '@mui/material';
import axios from 'axios';

const categories = [
    'Putty', 'Emulsion', 'Royal', 'Indigo',
    'Polish', 'Primer', 'Texture', 'Distemper', 'Others'
];

const finishes = ['Matt', 'Glossy', 'Satin', 'Silk', 'Metallic', 'None'];

const bases = ['Oil-Based', 'Water-Based', 'Solvent-Based', 'NA'];

const usageTypes = ['Interior', 'Exterior', 'Both'];

const units = ['sqft', 'liter', 'kg', 'can', 'gallon'];



const ProductManager = () => {
    const [product, setProduct] = useState({
        name: '',
        category: 'Others',
        brand: '',
        finish: 'None',
        base: 'NA',
        usageType: '',
        unit: '',
        priceWithLabor: '',
        priceWithoutLabor: '',
        estimatedCoverage: '',
        description: ''
    });

    const [loading, setLoading] = useState(false);

    const handleChange = (e) => {
        setProduct({ ...product, [e.target.name]: e.target.value });
    };



    const handleSubmit = async () => {
        console.log('Final Product:', product);

        const token = localStorage.getItem('token');

        try {
            await axios.post(
                `${process.env.REACT_APP_MY_API}/api/products`,
                product,
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                    },
                }
            );

            alert('Product added successfully!');

            // ✅ Reset the form after successful submission
            setProduct({
                name: '',
                category: '',
                brand: '',
                finish: '',
                base: '',
                usageType: '',
                unit: '',
                priceWithLabor: '',
                priceWithoutLabor: '',
                estimatedCoverage: '',
                description: '',
                imageUrl: '',
                isAvailable: true,
                clientCompany: ''
            });
        } catch (err) {
            console.error('Error submitting product:', err);
            alert('Something went wrong!');
        }
    };


    return (
        <Paper sx={{ p: 3, maxWidth: 800, mx: 'auto' }}>
            <Typography variant="h6" gutterBottom>
                Add Product
            </Typography>

            <Grid container spacing={2}>
                <Grid item xs={12} sm={6}>
                    <TextField fullWidth name="name" label="Product Name" value={product.name} onChange={handleChange} />
                </Grid>
                <Grid item xs={12} sm={6}>
                    <TextField fullWidth name="brand" label="Brand" value={product.brand} onChange={handleChange} />
                </Grid>

                <Grid item xs={12} sm={6}>
                    <TextField select fullWidth name="category" label="Category" value={product.category} onChange={handleChange}>
                        {categories.map((cat) => (
                            <MenuItem key={cat} value={cat}>{cat}</MenuItem>
                        ))}
                    </TextField>
                </Grid>

                <Grid item xs={12} sm={6}>
                    <TextField select fullWidth name="finish" label="Finish" value={product.finish} onChange={handleChange}>
                        {finishes.map((f) => (
                            <MenuItem key={f} value={f}>{f}</MenuItem>
                        ))}
                    </TextField>
                </Grid>

                <Grid item xs={12} sm={6}>
                    <TextField select fullWidth name="base" label="Base" value={product.base} onChange={handleChange}>
                        {bases.map((b) => (
                            <MenuItem key={b} value={b}>{b}</MenuItem>
                        ))}
                    </TextField>
                </Grid>

                <Grid item xs={12} sm={6}>
                    <TextField select fullWidth name="usageType" label="Usage Type" value={product.usageType} onChange={handleChange}>
                        {usageTypes.map((u) => (
                            <MenuItem key={u} value={u}>{u}</MenuItem>
                        ))}
                    </TextField>
                </Grid>

                <Grid item xs={12} sm={6}>
                    <TextField select fullWidth name="unit" label="Unit" value={product.unit} onChange={handleChange}>
                        {units.map((u) => (
                            <MenuItem key={u} value={u}>{u}</MenuItem>
                        ))}
                    </TextField>
                </Grid>

                <Grid item xs={12} sm={6}>
                    <TextField fullWidth type="number" name="priceWithLabor" label="Price With Labor" value={product.priceWithLabor} onChange={handleChange} />
                </Grid>

                <Grid item xs={12} sm={6}>
                    <TextField fullWidth type="number" name="priceWithoutLabor" label="Price Without Labor" value={product.priceWithoutLabor} onChange={handleChange} />
                </Grid>

                <Grid item xs={12} sm={6}>
                    <TextField fullWidth type="number" name="estimatedCoverage" label="Estimated Coverage" value={product.estimatedCoverage} onChange={handleChange} />
                </Grid>

                <Grid item xs={12}>
                    <TextField fullWidth multiline rows={3} name="description" label="Description" value={product.description} onChange={handleChange} />
                </Grid>

            </Grid>

            <Button
                variant="contained"
                color="primary"
                sx={{ mt: 3 }}
                onClick={handleSubmit}
                disabled={loading}
            >
                Add Product
            </Button>
        </Paper>
    );
};

export default ProductManager;
